import React, { FC } from 'react'

import { useSelector } from 'react-redux'
import { channelSelector } from 'redux-store/channel/channel.selectors'
import ChannelLogo from '../components/ChannelLogo'
import classNames from 'classnames'
import { NATIVE_APP_HELPER } from 'constants/native_app_helper.constants'

import styles from './ThemedHeader.module.scss'

export const NativeThemedHeader: FC = () => {
  const channel = useSelector(channelSelector)
  const logo = channel?.data?.parent_logo_url
  const rootChannelSubdomain = channel?.data?.parentChannelSubdomain
  const isRootClubChannel = channel?.data?.isRootClubChannel
  const isRootTeamChannel = channel?.data?.isRootTeamChannel

  return (
    <div
      className={classNames(styles.ThemedHeader, {
        [styles.NavigationHeaderWithoutMenuItems]:
          isRootClubChannel | isRootTeamChannel
      })}
      data-testid="navigation-menu-container"
    >
      {NATIVE_APP_HELPER.GET_PLATFORM === 'ios' && (
        <div style={{ height: '25px' }} />
      )}
      <ChannelLogo
        logoPath={logo}
        channelName={channel.data?.name}
        rootChannelSubdomain={rootChannelSubdomain}
      />
    </div>
  )
}
